import React from 'react';
import { Typewriter } from 'react-simple-typewriter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';
import pfp from '../../images/soorajpic1.jpg';

const Home = () => {
  const handleScrollTo = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative overflow-hidden bg-bg text-ink min-h-screen flex items-center"
    >
      <div className="absolute inset-0 grid-backdrop opacity-60 pointer-events-none" />

      <div className="relative container mx-auto px-6 pt-28 pb-24">
        <div className="grid lg:grid-cols-12 gap-16 items-center">
          <div className="lg:col-span-8 animate-fade-in-up">
            <h1 className="section-title text-5xl sm:text-7xl md:text-[5.5rem] text-ink">
              Sooraj Tharumia<span className="text-accent">.</span>
            </h1>

            <p className="mt-8 max-w-xl text-ink-muted text-lg md:text-xl leading-relaxed">
              Firmware and low-level software engineer. Currently building{' '}
              <span className="text-accent">
                <Typewriter
                  words={[
                    'firmware for microcontrollers',
                    'real-time embedded systems',
                    'autonomous platforms',
                    'low-level software',
                    'GPU-accelerated compute',
                    'robotics systems',
                  ]}
                  loop={0}
                  cursor
                  cursorStyle="▌"
                  typeSpeed={70}
                  deleteSpeed={40}
                  delaySpeed={1600}
                />
              </span>
              .
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href="#contact"
                onClick={handleScrollTo('contact')}
                className="btn-primary"
              >
                Get in touch
              </a>
              <a
                href="#projects"
                onClick={handleScrollTo('projects')}
                className="btn-ghost"
              >
                See projects
                <span>→</span>
              </a>

              <div className="flex items-center gap-2 ml-2">
                <a
                  href="https://www.linkedin.com/in/soorajtharumia"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  className="w-10 h-10 flex items-center justify-center border border-line text-ink-muted hover:text-accent hover:border-accent transition-colors"
                >
                  <FontAwesomeIcon icon={faLinkedin} />
                </a>
                <a
                  href="https://github.com/soorajtharumia"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="GitHub"
                  className="w-10 h-10 flex items-center justify-center border border-line text-ink-muted hover:text-accent hover:border-accent transition-colors"
                >
                  <FontAwesomeIcon icon={faGithub} />
                </a>
              </div>
            </div>
          </div>

          <div className="lg:col-span-4 animate-fade-in-up">
            <div className="relative mx-auto w-64 h-64 sm:w-72 sm:h-72 lg:w-80 lg:h-80">
              <div
                aria-hidden
                className="absolute -inset-2 rounded-full border border-accent/30"
              />
              <img
                src={pfp}
                alt="Sooraj Tharumia"
                className="relative w-full h-full object-cover rounded-full border border-line"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
